import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { RenderNumberPercentage } from "../../../../../../Utils/renderField/renderReadField";
import { calcularPromediosDRC } from "../../helpers/datosDRC";

export const PromediosDRC = ({ datosDRC = [] }) => {
    const { drc_promedio, drc_minimo, drc_maximo, drc_diferencia } =
        calcularPromediosDRC(datosDRC);

    return (
        <CardEmpty noShadow>
            <h6>RESULTADO DE DRC</h6>

            <div className="formulario-fields-row">
                <div className="formulario-field">
                    <label htmlFor="drc_promedio">PROMEDIO</label>
                    <RenderNumberPercentage
                        value={drc_promedio}
                        className="form-control analisis-drc-prod__datos-drc-disabled-field"
                        decimalScale={3}
                    />
                </div>

                <div className="formulario-field">
                    <label htmlFor="drc_minimo">MÍNIMO</label>
                    <RenderNumberPercentage
                        value={drc_minimo}
                        className="form-control analisis-drc-prod__datos-drc-disabled-field"
                        decimalScale={3}
                    />
                </div>

                <div className="formulario-field">
                    <label htmlFor="drc_maximo">MÁXIMO</label>
                    <RenderNumberPercentage
                        value={drc_maximo}
                        className="form-control analisis-drc-prod__datos-drc-disabled-field"
                        decimalScale={3}
                    />
                </div>

                <div className="formulario-field">
                    <label htmlFor="drc_diferencia">DIFERENCIA</label>
                    <RenderNumberPercentage
                        value={drc_diferencia}
                        className="form-control analisis-drc-prod__datos-drc-disabled-field"
                        decimalScale={3}
                    />
                </div>
            </div>
        </CardEmpty>
    );
};
